import { render, staticRenderFns } from "./CmgMealBuilderFooter.vue?vue&type=template&id=71bf6a6f&scoped=true&lang=pug"
import script from "./cmg-meal-builder-footer.ts?vue&type=script&lang=ts&external"
export * from "./cmg-meal-builder-footer.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgMealBuilderFooter.vue?vue&type=style&index=0&id=71bf6a6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf6a6f",
  null
  
)

export default component.exports